import React from "react";
import PropTypes from "prop-types";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ReactNotificationComponent = ({ title, body,setNotification,setShow }) => {
  let hideNotif = title === "";

  if (!hideNotif) {
    toast.info(<Display />);
    setTimeout(()=>{
      setNotification({ title: "", body: "" })
      setShow(false)

    },3000)
  }

  function Display() {
    return (
      <div>
        <h4>{title}</h4>
        {body&&<div  dangerouslySetInnerHTML={{ __html: body }}/>}
      </div>
    );
  }

  return (
    <ToastContainer
      autoClose={3000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover={false}
    />
  );
};

ReactNotificationComponent.defaultProps = {
  title: "This is title",
  body: "Some body",
};

ReactNotificationComponent.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
};

export default ReactNotificationComponent;